export default [
  {
    name: 'Monitor',
    path: '/monitor/:account',
    component: () => import(/* webpackChunkName: "monitor" */ '@/views/monitor/MonitorLock.vue'),
    meta: { authUser: true }
  },
  {
    path: '/monitor/:account',
    component: () => import(/* webpackChunkName: "monitor" */ '@/layouts/Monitor.vue'),
    meta: { auth: true },
    beforeEnter (to, from, next) {
      if (from.name !== 'Monitor') {
        next({ name: 'Monitor', params: to.params })
      } else {
        next()
      }
    },
    children: [
      {
        name: 'MonitorMap',
        path: 'map',
        meta: { product: 'monitor' },
        component: () => import(/* webpackChunkName: "monitor" */ '@/views/monitor/MonitorMap.vue')
      },
    ]
  }
]
